<div a-style display=flex h="84vh" w="100%" justify=center alignItems=center>
  <ng-content></ng-content>
</div>
<!-- [fs]="fs?fs:1.1"minHeight="minHeight?minHeight:calc( 100vh - 15rem )"  -->